<template>
  <section v-loading="loading" class="page-stack">
    <div v-if="data" class="overview-hero">
      <div>
        <p class="eyebrow">THIS MONTH · REAL REVENUE</p>
        <h2>本月真实流水</h2>
        <strong class="hero-amount">{{ coins(data.snapshot.gross_coin_amount) }}</strong><span>金币</span>
        <p>约 {{ usd(data.snapshot.gross_coin_amount) }} · 仅包含礼物、投喂和付费内容成功订单</p>
      </div>
      <div class="level-orbit">
        <div class="level-ring"><strong>{{ data.snapshot.level }}</strong><span>公会等级</span></div>
        <div class="level-copy">
          <span>下一等级进度</span>
          <el-progress :percentage="levelProgress" :show-text="false" :stroke-width="8" color="#42e6b3" />
          <small>{{ coins(data.snapshot.gross_coin_amount) }} / {{ coins(data.snapshot.rule.target_coins) }} 金币</small>
        </div>
      </div>
    </div>
    <div v-if="data" class="metric-grid">
      <article><span class="metric-icon mint"><i class="el-icon-user" /></span><div><small>在会主播</small><strong>{{ data.snapshot.member_count }}</strong><p>本月活跃 {{ data.snapshot.active_member_count }} 人</p></div></article>
      <article><span class="metric-icon gold"><i class="el-icon-wallet" /></span><div><small>预计公会收益</small><strong>{{ coins(data.snapshot.guild_income_coin_amount) }}</strong><p>当前可提现 {{ coins(data.available_coin_amount) }}</p></div></article>
      <article><span class="metric-icon blue"><i class="el-icon-s-order" /></span><div><small>主播预计分润</small><strong>{{ coins(data.snapshot.creator_share_coin_amount) }}</strong><p>按成员当前分润比例估算</p></div></article>
      <article><span class="metric-icon coral"><i class="el-icon-warning-outline" /></span><div><small>待处理关系申请</small><strong>{{ data.pending_requests }}</strong><p>包含入会、退会与转会</p></div></article>
    </div>
    <div v-if="data" class="overview-columns">
      <article class="panel policy-panel">
        <div class="panel-head"><div><p class="eyebrow">LEVEL POLICY</p><h3>{{ data.snapshot.level }} 级公会本月目标</h3></div><span :class="['status-chip', data.snapshot.qualified ? 'success' : 'warning']">{{ data.snapshot.qualified ? "已达标" : "进行中" }}</span></div>
        <div class="policy-row"><span>流水目标</span><strong>{{ usd(data.snapshot.rule.target_coins) }}</strong></div>
        <div class="policy-row"><span>活跃主播</span><strong>{{ data.snapshot.rule.min_active }}–{{ data.snapshot.rule.max_active }} 人</strong></div>
        <div class="policy-row"><span>公会可分配比例</span><strong>{{ data.snapshot.rule.allocation_bps / 100 }}%</strong></div>
        <div class="policy-row"><span>未达标奖励扣减</span><strong>{{ data.snapshot.rule.penalty_bps / 100 }}%</strong></div>
        <button class="text-link" @click="$emit('navigate','analytics')">查看完整数据 <i class="el-icon-right" /></button>
      </article>
      <article class="panel action-panel">
        <div class="panel-head"><div><p class="eyebrow">QUICK ACTIONS</p><h3>今天要处理什么？</h3></div></div>
        <button @click="$emit('navigate','members')"><i class="el-icon-user-solid" /><div><strong>邀请新主播</strong><span>通过主播 ID 或账号搜索</span></div><b class="el-icon-right" /></button>
        <button @click="$emit('navigate','requests')"><i class="el-icon-finished" /><div><strong>处理关系申请</strong><span>{{ data.pending_requests }} 条等待处理</span></div><b class="el-icon-right" /></button>
        <button @click="$emit('navigate','finance')"><i class="el-icon-wallet" /><div><strong>查看结算与提现</strong><span>可提现 {{ coins(data.available_coin_amount) }} 金币</span></div><b class="el-icon-right" /></button>
      </article>
    </div>
  </section>
</template>
<script>
import { overviewGet } from "../api/guild"
export default {
  name: "OverviewView",
  data: () => ({ data: null, loading: false }),
  computed: {
    levelProgress() {
      if (!this.data) return 0
      return Math.min(100, Math.round(this.data.snapshot.gross_coin_amount / Math.max(1, this.data.snapshot.rule.target_coins) * 100))
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await overviewGet()
        this.data = res.data
        this.$emit("unread", Number(res.data.unread_messages))
      } finally { this.loading = false }
    },
    coins(value) { return new Intl.NumberFormat("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value || 0)) },
    usd(value) { return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(value || 0) / 100) }
  }
}
</script>
